import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import './Hero.css';
import "swiper/css/autoplay";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css/pagination";

//video import
import v1 from "../assest/e-commorce.webm";
import v2 from "../assest/erp.webm";
import v3 from "../assest/facebook.webm";
import v4 from "../assest/mobile.webm";
import v5 from "../assest/web_desing.webm";

// import image
import img0 from "../assest/home-about.jpg";
import img1 from "../assest/logo/html.png";
import img2 from "../assest/logo/css.png";
import img3 from "../assest/logo/js.png";
import img4 from "../assest/logo/jquery.png";
import img5 from "../assest/logo/php.png";
import img6 from "../assest/logo/sql.png";
import img7 from "../assest/logo/koha.png";
import img8 from "../assest/client/3163uptti.png";
import img9 from "../assest/client/4086logo-of-gd1.png";
import img10 from "../assest/client/4340logo.png";
import img11 from "../assest/client/4340logo.png";
import img12 from "../assest/client/49473.png";
import img13 from "../assest/client/9053shellys-logo-tagline.png";
import img14 from "../assest/client/armapore-pg-college.png";
import img15 from "../assest/client/fmt-logo.png";
import img16 from "../assest/client/pan-parag.png";













const Body = () => {
  return (
    <div className="body-container">

      {/* Background Animation */}
      <div className="bg-blobs"></div>
      <div className="bg-blobs2"></div>
      <div className="floating-dots"></div>

      {/* ABOUT US Section */}
        <section className="about-section">

        {/* Decorative Floating Shapes */}
            <div className="about-blob1"></div>
            <div className="about-blob2"></div>

        {/* Heading */}
            <h2 className="section-heading">
                <span className="line"></span> About Us<span className="line"></span>
            </h2>

            <div className="about-wrapper container">
                <div className="row align-items-center">

                    {/* Left Text Section */}
                    <div className="col-md-6 about-text fade-in">
                        <h3 className="about-title">A Few Words About Us</h3>

                        <p>
                            Click Informatics is dedicated to providing you the best solutions
                            at a very affordable price without compromising on quality and standards.
                            Client satisfaction is our foremost goal.
                        </p>

                        <p>
                            We don’t just build websites — we craft premium digital experiences using modern UI/UX, branding strategy, and cutting-edge technology.
                        </p>
                        <button className="btn-readmore btn btn-success btn-lg">Read More </button>
                    </div>

                    {/* Right Side Image */}
                    <div className="col-md-6 about-image fade-in">
                        <div className="image-frame">
                            <img src={img0} alt="About" className="about-img"/>
                        </div>
                    </div>

                </div>
            </div>
        </section>
        <div class="container" style={{paddingBottom:"50px"}}>
            <div class="row text-center">
                <div class="col-md-3">
                    <div class="counter">
                        <i class="fas fa-project-diagram fa-3x mb-3" style={{color: "#e74c3c"}}></i>
                        <h2 class="count" data-target="850"><strong>850</strong></h2>
                        <p><strong>Projects Completed</strong></p>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="counter">
                        <i class="fas fa-users fa-3x mb-3" style={{color: "#e74c3c"}}></i>
                        <h2 class="count" data-target="120"><strong>120</strong></h2>
                        <p><strong>Happy Clients</strong></p>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="counter">
                        <i class="fas fa-code-branch fa-3x mb-3" style={{color: "#e74c3c"}}></i>
                        <h2 class="count" data-target="50"><strong>50</strong></h2>
                        <p><strong>Team Members</strong></p>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="counter">
                        <i class="fas fa-award fa-3x mb-3" style={{color: "#e74c3c"}}></i>
                        <h2 class="count" data-target="25"><strong>30</strong></h2>
                        <p><strong>Awards Won</strong></p>
                    </div>
                </div>
            </div>
        </div>
        
        {/* Section Heading */}
        <h2 className="section-heading">
            <span className="line">
            </span>Our Services<span className="line"></span>
        </h2>

        {/* Cards Wrapper */}
        <div className="cards-wrapper">

            {/* CARD 1 */}
            <div className="card video-card">
                <video src= {v5} autoPlay loop muted className="card-video"/>
                <h4 className="title">WEBSITE DESIGNING</h4>
                <p className="sub-text">
                    Website is the face of your business. A well-designed website ensures perfect delivery of your services.
                </p>
            </div>

            {/* CARD 2 */}
            <div className="card video-card">
                <video src={v1} autoPlay loop muted className="card-video"/>
                <h4 className="title">E-Commorce</h4>
                <p className="sub-text">
                    Smooth, modern and user-friendly UI/UX that enhances user engagement and satisfaction.
                </p>
            </div>

            {/* CARD 3 */}
            <div className="card video-card">
                <video src= {v2} autoPlay loop  muted className="card-video" />
                <h4 className="title">CUSTOMIZED ERP'S</h4>
                <p className="sub-text">
                    Increase your website ranking with high-quality SEO and performance optimization.
                </p>
            </div>

        </div>
        <div className="cards-wrapper">

            {/* CARD 1 */}
            <div className="card video-card">
                <video src={v3} autoPlay loop muted className="card-video" />
                <h4 className="title">Facebook</h4>
                <p className="sub-text">
                    Website is the face of your business. A well-designed website ensures perfect delivery of your services.
                </p>
            </div>

            {/* CARD 2 */}
            <div className="card video-card">
                <video src={v4} autoPlay loop muted className="card-video" />
                <h4 className="title">ANDROID APPLICATION DEVELOPMENT</h4>
                <p className="sub-text">
                    Smooth, modern and user-friendly UI/UX that enhances user engagement and satisfaction.
                </p>
            </div>

            {/* CARD 3 */}
            <div className="card video-card">
                <video src={v5} autoPlay loop muted className="card-video" />
                <h4 className="title">SEO OPTIMIZATION</h4>
                <p className="sub-text">
                    Increase your website ranking with high-quality SEO and performance optimization.
                </p>
            </div>

        </div>
        {/* <button className="btn-readmore btn btn-success btn-lg ">Read More </button> */}

        <h2 className="section-heading" style={{ marginTop: "50px" }}>
            <span className="line"></span>Our Technology<span className="line"></span>  
        </h2>

        <Swiper  spaceBetween={20} slidesPerView={3}
            loop={true}
            autoplay={{ delay: 2000 }}
            modules={[Autoplay]}
            className="tech-slider"
            breakpoints={{
                0: { slidesPerView: 1 },
                576: { slidesPerView: 2 },
                768: { slidesPerView: 5 },
            }}>

            {/* CARD 1 */}
            <SwiperSlide>
                <div className="card card-img">
                    <img src={img1} className="" />
                    <h4 className="title">HTML</h4>
                </div>
            </SwiperSlide>

            {/* CARD 2 */}
            <SwiperSlide>
                <div className="card card-img">
                    <img src={img2} autoPlay loop muted className="" />
                    <h4 className="title">CSS</h4>
                </div>
            </SwiperSlide>

            {/* CARD 3 */}
            <SwiperSlide>
                <div className="card card-img">
                    <img src={img3} autoPlay loop muted className="" />
                    <h4 className="title">Java Script</h4>
                </div>
            </SwiperSlide>

            {/* CARD 4 */}
            <SwiperSlide>
                <div className="card card-img">
                    <img src={img4} autoPlay loop muted className="" />
                    <h4 className="title">JQuery</h4>
                </div>
            </SwiperSlide>

            {/* CARD 5 */}
            <SwiperSlide>
                <div className="card card-img">
                    <img src= {img5} autoPlay loop muted className="" />
                    <h4 className="title">PHP</h4>
                </div>
            </SwiperSlide>

            {/* CARD 6 */}
            <SwiperSlide>
                <div className="card card-img">
                    <img src={img6} autoPlay loop muted className="" />
                    <h4 className="title">My SQL</h4>
                </div>
            </SwiperSlide>

            {/* CARD 7 */}
            <SwiperSlide>
                <div className="card card-img">
                    <img src={img7} autoPlay loop muted className="" />
                    <h4 className="title">Koha Library</h4>
                </div>
            </SwiperSlide>
        </Swiper>
        <div class="container">
            <div class="section-title">
                <h2 className="section-heading" style={{ marginTop: "60px" }}>
                    <span className="line"></span>Our Clients<span className="line"></span>
                </h2>
                <p>We're proud to have worked with these amazing companies</p>
            </div>
            
            <Swiper spaceBetween={25} slidesPerView={3} loop={true} autoplay={{ delay: 2000 }}
                modules={[Autoplay]} className="clients-slider" breakpoints={{0: { slidesPerView: 1 },
                576: { slidesPerView: 2 }, 768: { slidesPerView: 5 },}}>


            {/* CARD 1 */}
            <SwiperSlide>
                <a href="">
                    <div className="card1 card-img">
                        <img src={img8} className="" />
                        {/* <h4 className="title">HTML</h4> */}
                    </div>
                </a>
            </SwiperSlide>

            {/* CARD 2 */}
            <SwiperSlide>
                <a href="">
                <div className="card1 card-img">
                    <img src={img9} autoPlay loop muted className="" />
                    {/* <h4 className="title">CSS</h4> */}
                </div>
                </a>
            </SwiperSlide>

            {/* CARD 3 */}
            <SwiperSlide>
                <a href="">
                <div className="card1 card-img">
                    <img src={img10} autoPlay loop muted className="" />
                    {/* <h4 className="title">Java Script</h4> */}
                </div>
                </a>
            </SwiperSlide>

            {/* CARD 4 */}
            <SwiperSlide>
                <a href="">
                <div className="card1 card-img">
                    <img src={img11} autoPlay loop muted className="" />
                    {/* <h4 className="title">JQuery</h4> */}
                </div>
                </a>
            </SwiperSlide>

            {/* CARD 5 */}
            <SwiperSlide>
                <a href="">
                <div className="card1 card-img">
                    <img src= {img12} autoPlay loop muted className="" />
                    {/* <h4 className="title">PHP</h4> */}
                </div>
                </a>
            </SwiperSlide>

            {/* CARD 6 */}
            <SwiperSlide>
                <a href="">
                <div className="card1 card-img">
                    <img src={img13} autoPlay loop muted className="" />
                    {/* <h4 className="title">My SQL</h4> */}
                </div>
                </a>
            </SwiperSlide>

            {/* CARD 7 */}
            <SwiperSlide>
                <a href="">
                <div className="card1 card-img">
                    <img src={img14} autoPlay loop muted className="" />
                    {/* <h4 className="title">Koha Library</h4> */}
                </div>
                </a>
            </SwiperSlide>

            {/* CARD 8 */}
            <SwiperSlide>
                <a href="">
                <div className="card1 card-img">
                    <img src={img14} autoPlay loop muted className="" />
                    {/* <h4 className="title">My SQL</h4> */}
                </div>
                </a>
            </SwiperSlide>

            {/* CARD 9 */}
            <SwiperSlide>
                <a href="">
                <div className="card1 card-img">
                    <img src={img15} autoPlay loop muted className="" />
                    {/* <h4 className="title">Koha Library</h4> */}
                </div>
                </a>
            </SwiperSlide>
        </Swiper>
        </div>
        {/* ===================== TESTIMONIAL SECTION ===================== */}
        <h2 className="section-heading" style={{ marginTop: "60px" }}>
            <span className="line"></span>What Our Customers Say<span className="line"></span>
        </h2>

        <div className="testimonial-section">
            <Swiper spaceBetween={30} slidesPerView={1} loop={true} autoplay={{ delay: 3000 }} pagination={{ clickable: true }} modules={[Autoplay, Pagination]} className="testimonial-slider" >
                {/* Testimonial 1 */}
                <SwiperSlide>
                    <div className="testimonial-card">
                        <p className="testimonial-text">
                            "Click Informatics delivered our website exactly as we wanted. Fast, secure and beautifully designed!"
                        </p>
                        <h4 className="testimonial-name">— Rahul Verma</h4>
                    </div>
                </SwiperSlide>

                {/* Testimonial 2 */}
                <SwiperSlide>
                    <div className="testimonial-card">
                        <p className="testimonial-text">
                            "Amazing team! They created our mobile app with modern UI and fast performance."
                        </p>
                        <h4 className="testimonial-name">— Priya Sharma</h4>
                    </div>
                </SwiperSlide>

                {/* Testimonial 3 */}
                <SwiperSlide>
                    <div className="testimonial-card">
                        <p className="testimonial-text">
                            "Great support and very professional service. Highly recommended!"
                        </p>
                        <h4 className="testimonial-name">— Manish Gupta</h4>
                    </div>
                </SwiperSlide>
            </Swiper>
        </div>
           
    </div>
  );
};

export default Body;
